import crud from '../crud'
var p = new crud('order_flags', 'hashtag');

export default {
    actions: {...p.actions},
    mutations: {...p.mutations},
    namespaced: true,
    state: {...p.state},
};
